/* unplugin-vue-components disabled */import { render } from "./FooterForPC.vue?vue&type=template&id=609575c0&scoped=true"
import script from "./FooterForPC.vue?vue&type=script&lang=js"
export * from "./FooterForPC.vue?vue&type=script&lang=js"

import "./FooterForPC.vue?vue&type=style&index=0&id=609575c0&lang=less&scoped=true"

import exportComponent from "/root/workspace/coottlVideoPage_JjFl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609575c0"]])

export default __exports__